import { useQuery } from "react-query"
import { getCustomerEmails } from "./customerApi"

export const useCustomerEmailsQuery = (customerId: number) => {
  return useQuery(['customerEmails', customerId], {
    queryFn: () => getCustomerEmails(customerId),
    enabled: customerId > 0,
    staleTime: 30 * 1000
  })
}
